import React from 'react';

const FilterBar = () => {
  return (
    <button className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mb-4">
      Filters
    </button>
  );
};

export default FilterBar;